/**
 * Dominion navigation: native button activation, hover and keyboard disclosure.
 * Keeps Air-light's walker markup and CSS state classes.
 */
function initNavigation() {
  const nav = document.querySelector('.nav-primary');
  const toggle = document.getElementById('nav-toggle');
  const wrapper = document.getElementById('menu-items-wrapper');
  if (!nav || !toggle || !wrapper) return;

  const breakpoint = getComputedStyle(document.documentElement).getPropertyValue('--breakpoint-nav').trim();
  const mobile = window.matchMedia(`(max-width: ${breakpoint})`);
  const labels = window.dominion_screenReaderText;
  const buttons = [...nav.querySelectorAll('.dropdown-toggle')];

  function setSubmenu(button, open) {
    button.setAttribute('aria-expanded', String(open));
    const link = button.parentElement.querySelector('a');
    button.setAttribute('aria-label', `${open ? labels.collapse_for : labels.expand_for} ${link.textContent.trim()}`);
    button.classList.toggle('toggled-on', open);
    button.parentElement.classList.toggle('hover-intent', open);
    button.nextElementSibling.classList.toggle('toggled-on', open);
    if (!open) {
      button.nextElementSibling.querySelectorAll('.dropdown-toggle').forEach(child => setSubmenu(child, false));
    }
  }

  function closeSubmenus() {
    buttons.forEach(button => setSubmenu(button, false));
  }

  function positionPanel() {
    if (mobile.matches) {
      const bottom = document.querySelector('.site-header').getBoundingClientRect().bottom;
      wrapper.style.top = `${bottom}px`;
      wrapper.style.height = `calc(100dvh - ${bottom}px)`;
    } else {
      wrapper.style.top = '';
      wrapper.style.height = '';
    }
  }

  function setMobile(open, restoreFocus = false) {
    document.body.classList.toggle('js-nav-active', open);
    toggle.setAttribute('aria-expanded', String(open));
    toggle.setAttribute('aria-label', open ? labels.collapse_toggle : labels.expand_toggle);
    wrapper.inert = mobile.matches && !open;
    if (open) {
      window.scrollTo(0, 0);
      positionPanel();
    } else {
      closeSubmenus();
      if (restoreFocus) toggle.focus();
    }
  }

  buttons.forEach((button, index) => {
    const submenu = button.nextElementSibling;
    submenu.id = `navigation-submenu-${index}`;
    button.setAttribute('aria-controls', submenu.id);
    setSubmenu(button, false);
    // Buttons emit one click for mouse, Enter and Space.
    button.addEventListener('click', () => {
      setSubmenu(button, button.getAttribute('aria-expanded') !== 'true');
    });
    button.parentElement.addEventListener('pointerenter', event => {
      if (!mobile.matches && event.pointerType === 'mouse') setSubmenu(button, true);
    });
    button.parentElement.addEventListener('pointerleave', () => {
      if (!mobile.matches && !button.parentElement.contains(document.activeElement)) setSubmenu(button, false);
    });
    button.parentElement.addEventListener('focusout', () => {
      window.setTimeout(() => {
        if (!button.parentElement.contains(document.activeElement)) setSubmenu(button, false);
      }, 0);
    });
  });

  toggle.addEventListener('click', () => setMobile(toggle.getAttribute('aria-expanded') !== 'true'));
  nav.addEventListener('keydown', event => {
    if (event.key === 'Escape') {
      const item = event.target.closest('.menu-item-has-children');
      const button = item?.querySelector(':scope > .dropdown-toggle');
      if (button?.getAttribute('aria-expanded') === 'true') {
        setSubmenu(button, false);
        button.focus();
      } else if (mobile.matches && toggle.getAttribute('aria-expanded') === 'true') {
        setMobile(false, true);
      }
      event.preventDefault();
    }
    if (event.key === 'ArrowDown' && event.target.classList.contains('dropdown-toggle')) {
      setSubmenu(event.target, true);
      event.target.nextElementSibling.querySelector('a').focus();
      event.preventDefault();
    }
    if (event.key === 'Tab' && mobile.matches && toggle.getAttribute('aria-expanded') === 'true') {
      const focusable = [...nav.querySelectorAll('a, button')].filter(element =>
        element.getClientRects().length && getComputedStyle(element).visibility !== 'hidden');
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && event.target === first) {
        last.focus();
        event.preventDefault();
      } else if (!event.shiftKey && event.target === last) {
        first.focus();
        event.preventDefault();
      }
    }
  });
  document.addEventListener('click', event => {
    if (!nav.contains(event.target) && !mobile.matches) closeSubmenus();
  });
  mobile.addEventListener('change', () => {
    const wasOpen = toggle.getAttribute('aria-expanded') === 'true';
    setMobile(false);
    positionPanel();
    if (wasOpen) {
      if (mobile.matches) toggle.focus();
      else nav.querySelector('a').focus();
    }
  });
  window.addEventListener('resize', positionPanel);
  setMobile(false);
  positionPanel();
}

export default initNavigation;
